import { IssuePriority } from '@/entities/issue';
import { ScoreTriggerEditable } from '@/ui/DTO';
import { v4 as uuidv4 } from 'uuid';
import { DueAfter } from '@/entities/issueTemplate';

export interface IssueTemplateEditable {
  // if resource has an `id` it means this was created
  // in the backend already. Therefore, we need to update
  // when we save the checklist template
  id?: number;
  title: string;
  description: string | null;
  priority: IssuePriority;
  assignees: number[];
  approvers: number[];
  approvalsEnabled: boolean;
  approvalsEntitySpecificAssignments: boolean;
  assignedGroups: number[];
  associateAssignees: string[];
  dueIn: null | DueAfter;
  scoreTrigger: null | ScoreTriggerEditable;
  // from here on it is fields that help the frontend
  // work with a mix of resources from the BE and FE entities
  internalId: string;
  entityItemSpecificAssignments: boolean;
  wasChanged: boolean;
  softDeleted: boolean;
}

export const emptyIssueTemplate = (): IssueTemplateEditable => ({
  title: '',
  description: null,
  priority: IssuePriority.Normal,
  assignees: [],
  approvers: [],
  approvalsEnabled: false,
  approvalsEntitySpecificAssignments: false,
  assignedGroups: [],
  associateAssignees: [],
  dueIn: null,
  scoreTrigger: null,
  internalId: uuidv4(),
  entityItemSpecificAssignments: false,
  wasChanged: false,
  softDeleted: false,
});

export const emptyDueAfter = (): DueAfter => ({
  weeks: null,
  days: null,
  hours: null,
  minutes: null,
});
